import { gql } from '@apollo/client'

export const GET_ALL_PRODUCES = gql`
  query AllPieces(
    $str: String
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [TaxonomyProduceFunctionalUnitsGraphQLSortInput!]
  ) {
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    taxonomyProduceFunctionalUnit: __type(name: "TaxonomyProduceFunctionalUnitsGraphQL") {
      fields {
        name
        description
      }
    }

    taxonomyProduceFunctionalUnits(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { state: $state }
          { code: { contains: $str } }
          { class: { contains: $str } }
          { category: { contains: $str } }
          { subcategory: { contains: $str } }
          { functionalUnit: { contains: $str } }
          { functionalUnitProxy: { contains: $str } }
          { faoTrade: { contains: $str } }
          { faoProduction: { contains: $str } }
          { lastUpdatedName: { contains: $str } }
          { researcherName: { contains: $str } }
        ]
      }
      order: $order
    ) {
      totalCount
      edges {
        node {
          id
          code
          state
          class
          category
          subcategory
          functionalUnit
          functionalUnitProxy
          transportCondition
          faoTrade
          faoTradeSource
          faoProduction
          faoProductionSource
          isVerified
          verifiedOn
          lastPublishedDate
          lastUpdatedName
          updated
          researcherName
          created
        }

        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
